module.exports = __webpack_public_path__ + "static/img/11.90a6216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/11.png
// module id = AuVu
// module chunks = 1